import { DialogContentText } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced';
import { useTranslation } from 'react-i18next';

type ConfirmEquipmentSwitchDialogProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmEquipmentSwitchDialog = ({
  open,
  onCancel,
  onConfirm
}: ConfirmEquipmentSwitchDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      open={open}
      onClose={onCancel}
      onSubmit={onConfirm}
      submitLabel={t('actions.confirm')}
      title={t('actions.confirm')}>
      <DialogContentText>{t('pages.accessories.confirm-switch-equipment')}</DialogContentText>
    </EnhancedDialog>
  );
};

export default ConfirmEquipmentSwitchDialog;
